import { useRef, useState } from 'react';
import type { ChatMessage } from '../components/ChatComponents';
import { copyText } from '../utils/clipboard';

export function useMessageEditing() {
  const [editingMessageId, setEditingMessageId] = useState<string | null>(null);
  const [editingContent, setEditingContent] = useState('');
  const [copiedMessageId, setCopiedMessageId] = useState<string | null>(null);
  const copyTimerRef = useRef<ReturnType<typeof setTimeout>>(null);

  const handleStartEdit = (msg: ChatMessage) => {
    setEditingMessageId(msg.id);
    setEditingContent(msg.content);
  };

  const handleCancelEdit = () => {
    setEditingMessageId(null);
    setEditingContent('');
  };

  const handleCopyMessage = (msg: ChatMessage) => {
    copyText(msg.content);
    setCopiedMessageId(msg.id);
    if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
    copyTimerRef.current = setTimeout(() => setCopiedMessageId(null), 2000);
  };

  return {
    editingMessageId,
    editingContent,
    copiedMessageId,
    setEditingMessageId,
    setEditingContent,
    setCopiedMessageId,
    handleStartEdit,
    handleCancelEdit,
    handleCopyMessage,
  };
}
